import React, { useEffect, useState } from 'react';
import { Grid, InputLabel, FormControl, TextField, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, useMediaQuery, FormHelperText, Typography, Checkbox } from '@mui/material';
import styled, { inputImages, inputNumbers, inputStyles } from '../../Utils/inputChanges';

import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { createItemEntry, fetchItemData, fetchItemMaterialData, insertItemMaterial } from '../../Store/PHPSlice/Item';
import { selectBrandlist, selectItemMaterialData, selectItems, selectlocationdata } from '../Selectors/Master/ItemSelectors';
import { fetchBrandData } from '../../Store/PHPSlice/Rack';
import Dropdown from '../FieldsComponents/Dropdown';
import { useParams } from 'react-router-dom';
import { fetchLocationData } from '../../Store/PHPSlice/Transport';
import DropdownWithBtn from '../FieldsComponents/DropdownWithBtn';


const ItemMaterialEdit = () => {
    const userdata = JSON.parse(localStorage.getItem('user'));
    const { Id } = useParams();
    const [formData, setFormData] = useState({
        item: '',
        brand: '',
        userId: userdata?.ID,
        locId: ''
    });
    const [material, setMaterial] = useState([]);
    const [removeMaterial, setRemoveMaterial] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);

    const dispatch = useDispatch();

    const itemlist = useSelector(selectItems);
    const brandlist = useSelector(selectBrandlist);
    const materialdata = useSelector(selectItemMaterialData);
    const loclist = useSelector(selectlocationdata);

    useEffect(() => {
        dispatch(fetchItemData());
        dispatch(fetchBrandData());
        dispatch(fetchItemMaterialData(Id));
        dispatch(fetchLocationData());
    }, [dispatch, Id]);

    useEffect(() => {
        if (materialdata?.data?.length > 0) {
            let data = JSON.parse(JSON.stringify(materialdata?.data));

            setMaterial(data);
            const data2 = JSON.parse(JSON.stringify(materialdata?.data[0]));
            setFormData(prev => ({
                ...prev,
                item: data2.itemId,
                brand: data2.brandId
            }));
        }
    }, [materialdata]);


    const isDesktop = useMediaQuery('(min-width:768px)');

    const dropdownlistfirst = [
        {
            label: 'Item',
            id: 'item',
            options: itemlist?.data || [],
            value: formData.item,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'item', value: newValue ? newValue.ID : '' } }, 'item'),
            getOptionLabel: (option) => option.itemNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
        },
        {
            label: 'Brand',
            id: 'brand',
            options: brandlist?.data || [],
            value: formData.brand,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'brand', value: newValue ? newValue.ID : '' } }, 'brand'),
            getOptionLabel: (option) => option.brandNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
        }
    ];


    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;

        setFormData({
            ...formData,
            [dropdownType]: value
        });

    };

    const handleLumpColor = (index, value, name) => {
        const updatematerial = [...material];
        updatematerial[index][name] = value;
        setMaterial(updatematerial);
    };

    const handleAddlump = () => {
        const materialdata = {
            ID: 0,
            materialNm: '',
            qty: '',
            selected: false
        };
        setMaterial((prevRows) => [...prevRows, materialdata]);
    };

    const handleLumpSelection = (index) => {
        const newRows = [...material];
        newRows[index].selected = !newRows[index].selected;
        setMaterial(newRows);
    };

    const handleRemoveLumps = () => {
        const filteredRows = material.filter((row) => !row.selected);
        setMaterial(filteredRows);
        const removeRows = material.filter((row) => row.selected);
        setRemoveMaterial((prevRows) => [...prevRows, ...removeRows]);
        // const totmtr = filteredRows.reduce((acc, mtr) => acc + parseFloat(mtr.mtr), 0);
        // setLumpTotMtr(totmtr);
    };

    function postObj(formData, material, removeMaterial) {
        const data = {
            itemId: formData.item,
            brandId: formData.brand,
            userId: formData.userId,
            material: material,
            delMaterial: removeMaterial,
            locId: formData.locId
        };
        return data;
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const postdata = postObj(formData, material, removeMaterial);
        // console.log(postdata);
        dispatch(insertItemMaterial(postdata))
            .unwrap()
            .then((result) => {
                console.log('POST request successful!', result);
                // toast.success("Item Added");
                alert("Item Material Updated");
                window.close();
            })
            .catch((error) => {
                console.error('Error while making POST request:', error);
            });
    };


    return (
        <>

            <div style={{ margin: '1%' }}>
                <h2>Material Edit</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={1.2}>




                                {
                                    dropdownlistfirst && dropdownlistfirst?.map((drop) => (
                                        <Dropdown
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                        />
                                    ))
                                }

                                <div className="lump-content">
                                    {/* <h3>Material Entry </h3> */}
                                    <div className="button-group">
                                        <button className="add" onClick={handleAddlump}>Add</button>
                                        <button className="delete" onClick={handleRemoveLumps}>Remove</button>
                                    </div>
                                    <table style={{ width: '100%' }}>
                                        <thead>
                                            <tr>
                                                <th>Sr. No.</th>
                                                <th>Material</th>
                                                <th>Qty</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {material.map((mat, matIndex) => (
                                                <>
                                                    <tr key={matIndex}>
                                                        <td><input
                                                            type="checkbox"
                                                            checked={mat.selected}
                                                            onChange={() => handleLumpSelection(matIndex)}
                                                        />{" "}
                                                            {matIndex + 1}
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="text"
                                                                placeholder="material name"
                                                                value={mat.materialNm}
                                                                onChange={(e) => handleLumpColor(
                                                                    matIndex,
                                                                    e.target.value,
                                                                    "materialNm"
                                                                )}
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="text"
                                                                placeholder="qty"
                                                                value={mat.qty}
                                                                onChange={(e) => handleLumpColor(
                                                                    matIndex,
                                                                    e.target.value,
                                                                    "qty"
                                                                )}
                                                            />
                                                        </td>


                                                    </tr>
                                                </>
                                            ))}
                                            {/* <tr>
                                                <td> </td>
                                                <td> </td>
                                                <td>
                                                    <span className="tot-lump">Total Lump Mtr</span>
                                                </td>
                                                <td>
                                                    <span className="tot-lump">{lumpTotMtr}</span>
                                                </td>
                                            </tr> */}
                                        </tbody>
                                    </table>

                                </div>

                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit}>Update</Button>
                                </Grid>
                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        </>
    );
}

export default ItemMaterialEdit;
